import { Reveal, MaskedLines } from "@/components/Motion";
import { SectionLabel } from "@/components/SectionLabel";

const POINTS = [
  { t: "Recognition", d: "A consistent identity helps people recognise your business instantly — on a shelf, in a feed or across the street." },
  { t: "Clarity", d: "Good design organises information so customers understand what you offer and why it matters, without effort." },
  { t: "Credibility", d: "Polished, coherent visuals signal care and professionalism, giving new customers the confidence to get in touch." },
  { t: "Consistency", d: "When every touchpoint follows the same visual rules, your brand feels established and trustworthy wherever it appears." },
];

export const WhyDesign = () => (
  <section className="on-dark relative overflow-hidden bg-navy py-24 text-white sm:py-36" aria-labelledby="why-heading" data-testid="home-why-design">
    <div className="shell grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <SectionLabel index="04" dark>Why design matters</SectionLabel>
          <MaskedLines
            as="h2"
            className="mt-8 font-display text-4xl font-extrabold leading-[1.05] tracking-[-0.04em] sm:text-5xl lg:text-6xl"
            lines={[{ content: "Seen clearly." }, { content: "Understood quickly." }, { content: "Remembered.", className: "text-lime" }]}
          />
          <p className="mt-8 max-w-md text-base leading-relaxed text-white/80 sm:text-lg">
            Consistent visual communication helps businesses present themselves clearly and professionally — at every point where customers meet them.
          </p>
        </div>
      </div>
      <ul className="lg:col-span-6 lg:col-start-7">
        {POINTS.map((p, i) => (
          <Reveal as="li" key={p.t} delay={i * 0.05} className="group border-t border-white/15 py-10 last:border-b">
            <div className="flex items-baseline gap-6">
              <span className="font-mono text-xs text-lime">0{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl font-bold tracking-tight transition-colors duration-300 group-hover:text-lime sm:text-3xl">{p.t}</h3>
                <p className="mt-3 max-w-lg leading-relaxed text-white/80">{p.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
